import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

// ----------------------------------------------------------------------

const RHFTextField = React.forwardRef(({ name, helperText, ...other }, ref) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          ref={ref}
          fullWidth
          value={typeof field.value === "number" && field.value === 0 ? "" : field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          inputProps={{
            "aria-invalid": !!error || undefined,
            "aria-describedby": error ? `${name}-helper-text` : undefined,
            ...other.inputProps,
          }}
          FormHelperTextProps={{
            id: `${name}-helper-text`,
            ...other.FormHelperTextProps,
          }}
          {...other}
        />
      )}
    />
  );
});

RHFTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};
export default RHFTextField;
